module.exports = __webpack_public_path__ + "static/img/200121.7981788e.png";